module.exports = __webpack_public_path__ + "img/illus-service.f2e9a4ae.svg";